export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 1_03.89584558.jpg";